import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../../components/Icon/Icon.styles';

/** @class PaginationButtonMixin */
/** @method */
export var PaginationButtonMixin = token({
  radius: 'PaginationButton.radius',
  size: 'PaginationButton.size',
  padding: 'PaginationButton.padding'
}, function (_ref) {
  var radius = _ref.radius,
    size = _ref.size,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? 0 : _ref$padding;
  return css(["border-radius:", ";height:", "px;width:", "px;display:flex;align-items:center;justify-content:center;padding:", "px;&,&:hover{text-decoration:none;}&[aria-pressed='true']:disabled{opacity:1;}", "{margin:0;}"], radius, size, size, padding, StyledIcon);
});